import $axios from "../../api";
import { getDeviceId } from "../../utils/deviceId";

// Id percobaan simpan. Dibuat sekali per klik Draft / Konfirmasi lalu dikirim ke
// server sebagai idempotency key — bukan disimpan, karena setiap klik memang
// dimaksudkan sebagai simpanan baru.
function newSaveId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID().slice(0, 36);
  }

  return `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

const state = {
  isLoading: false,
  createLoading: false,
  exportTxtLoading: false,
  exportExcelLoading: false,
  exportPdfLoading: false,
  uploadPicProofLoading: false,
  syncProductLoading: false,
  syncMissingLoading: false,
  // Flag TERSENDIRI, sengaja tidak memakai isLoading: detail.vue mengikat
  // isLoading ke skeleton halaman DAN ke :disabled tombol Draft/Konfirmasi,
  // jadi memakainya untuk tiap penambahan baris membuat tombol simpan
  // berkedip setiap kali stocker mencatat satu penjualan.
  movementLineLoading: false,
  errors: "",
  isSuccess: false,
  list: {
    data: [],
    total: 0,
    per_page: 10,
    from: 0,
    to: 0,
  },
  detailLoading: false,
  detail: {},

  stockerPayload: null,
  page: 1,
};

const getters = {
  errors: (state) => {
    let errors = {};

    Object.keys(state.errors).forEach((key) => {
      const part = key.split(".");

      if (part[0] === "products" || part[0] === "additional_products") {
        const productIndex = Number(part[1]);
        
        errors[key] = state.errors[key][0] + ` (SKU: ${state.stockerPayload?.[part[0]][productIndex]?.sku || 'N/A'})`;

        if (part[3]) {
          const batchIndex = Number(part[3]);

          errors[key] += ` (Baris ke: ${batchIndex + 1})`;
        }
      }
    });
    return errors;
  },
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_MOVEMENT_LINE_LOADING(state, payload) {
    state.movementLineLoading = payload;
  },

  SET_CREATE_LOADING(state, payload) {
    state.createLoading = payload;
  },

  SET_ERRORS(state, payload) {
    state.errors = payload;
  },

  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },

  SET_LIST(state, payload) {
    state.list = payload;
  },

  SET_DETAIL(state, payload) {
    state.detail = payload;
  },

  SET_PAGE(state, payload) {
    state.page = payload;
  },
  
  RESET_DETAIL(state) {
    state.detail = [];
  },

  RESET_ERRORS(state) {
    state.errors = {};
  },

  RESET_STATE(state) {
    state.errors = {};
    state.isSuccess = false;
    state.createLoading = false;
  },

  SET_DETAIL_LOADING(state, val) {
    state.detailLoading = val;
  },

  SET_STOCKER_PAYLOAD(state, payload) {
    state.stockerPayload = payload;
  }
  ,
  SET_PRODUCT_DETAIL(state, payload) {
    state.detail = {
      ...state.detail,
      product_name: payload.product_name,
      sku: payload.sku
    };
  },
  SET_EXPORT_TXT_LOADING(state, value) {
    state.exportTxtLoading = value;
  },
  SET_EXPORT_EXCEL_LOADING(state, value) {
    state.exportExcelLoading = value;
  },
  SET_EXPORT_PDF_LOADING(state, value) {
    state.exportPdfLoading = value;
  },
  SET_UPLOAD_PIC_PROOF_LOADING(state, value) {
    state.uploadPicProofLoading = value;
  },
  SET_SYNC_PRODUCT_LOADING(state, value) {
    state.syncProductLoading = value;
  },
  SET_SYNC_MISSING_LOADING(state, value) {
    state.syncMissingLoading = value;
  },

  RESET_STOCKER_PAYLOAD(state) {
    state.stockerPayload = null;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload = "") {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(
          `inv/stock-opname/list?page=${state.page}&view=${rootState.Main.view}${payload}`
        )
        .then((response) => {
          commit("SET_LIST", response.data.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        });
    });
  },

  getView({ commit, dispatch }, docNum) {
    commit("SET_DETAIL_LOADING", true);
    commit("RESET_DETAIL");

    return $axios
      .get(`inv/stock-opname/view/${docNum}`)
      .then((res) => {
        commit("SET_DETAIL", res.data.data);
        return res;
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_DETAIL_LOADING", false);
      });
  },

  createVisit({ commit, dispatch }, payload) {
    commit("SET_CREATE_LOADING", true);
    commit("SET_ERRORS", null);
    commit("SET_SUCCESS", false);

    return $axios
      .post("inv/stock-opname/create", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        commit("SET_SUCCESS", true);

        dispatch(
          "Main/globalSuccessSweetAlert",
          response.data?.message || "Data berhasil disimpan",
          { root: true }
        );

        return response;
      })
      .catch((error) => {
        const errors = error.response?.data?.errors || null;

        commit("SET_ERRORS", errors);
        commit("SET_SUCCESS", false);

        dispatch(
          "Main/globalSweetAlert",
          error.response,
          { root: true }
        );

        throw error;
      })
      .finally(() => {
        commit("SET_CREATE_LOADING", false);
      });
  },


  updateVisit({ commit, dispatch }, payload) {
    commit("SET_CREATE_LOADING", true);
    commit("SET_SUCCESS", false);

    return new Promise((resolve, reject) => {
      $axios
        .post("inv/stock-opname/update", payload)
        .then((response) => {
          commit("SET_CREATE_LOADING", false);
          commit("SET_SUCCESS", true);

          dispatch(
            "Main/globalSuccessSweetAlert",
            response.data.message,
            { root: true }
          );

          resolve(response);
        })
        .catch((error) => {
          commit("SET_CREATE_LOADING", false);
          commit("SET_ERRORS", error.response?.data?.errors || "");
          commit("SET_SUCCESS", false);

          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );

          reject(error);
        });
    });
  },

  exportTxt({ commit }, id) {
    commit("SET_EXPORT_TXT_LOADING", true);

    return $axios
      .get(`inv/stock-opname/export/txt/${id}`, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/plain" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `stock-opname-${id}.txt`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      })
      .finally(() => {
        commit("SET_EXPORT_TXT_LOADING", false);
      });
  },

  /**
   * Unduh borongan (FR-05). Satu berkas, satu lembar per kunjungan.
   *
   * ⚠️ responseType blob + penolakan peladen = jebakan. Kalau peladen menolak
   * (mis. 21 kunjungan, AC-05.5), badan jawabannya JSON tapi axios sudah
   * terlanjur membungkusnya jadi Blob — `error.response.data.message` akan
   * undefined dan penggunanya cuma melihat "Coba lagi". Blob-nya dibaca balik
   * jadi teks supaya pesan yang menyebut batasnya benar-benar sampai.
   */
  exportExcelBulk({ commit, dispatch }, payload) {
    return $axios
      .post("inv/stock-opname/export/excel-bulk", { ids: payload.ids }, { responseType: "blob" })
      .then((res) => {
        let filename = "stock-opname-bulk.xlsx";

        const disposition = res.headers["content-disposition"];
        if (disposition && disposition.indexOf("filename=") !== -1) {
          const matches = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      })
      .catch(async (error) => {
        const data = error.response?.data;
        let message = "";

        if (data instanceof Blob) {
          try {
            message = JSON.parse(await data.text())?.message || "";
          } catch (e) {
            message = "";
          }
        } else {
          message = data?.message || "";
        }

        throw message;
      });
  },

  exportExcel({ commit, dispatch }, id) {
    commit("SET_EXPORT_EXCEL_LOADING", true);

    return $axios
      .get(`inv/stock-opname/export/excel/${id}`, {
        responseType: "blob",
      })
      .then((res) => {
        let filename = "export.xlsx";

        const disposition = res.headers["content-disposition"];
        if (disposition && disposition.indexOf("filename=") !== -1) {
          const matches = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_EXPORT_EXCEL_LOADING", false);
      });
  },

  exportPdf({ commit, dispatch }, id) {
    commit("SET_EXPORT_PDF_LOADING", true);

    return $axios
      .get(`inv/stock-opname/export/pdf/${id}`, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/pdf",
        });

        const url = window.URL.createObjectURL(blob);

        // 👉 OPEN PREVIEW DI TAB BARU
        window.open(url, "_blank");

        // revoke setelah delay biar tab kebuka dulu
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_EXPORT_PDF_LOADING", false);
      });
  },
  
  showhide({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);

    return new Promise((resolve, reject) => {
      $axios
        .post("inv/stock-opname/showhide", payload)
        .then((response) => {
          commit("SET_SUCCESS", true);

          dispatch(
            "Main/globalSuccessSweetAlert",
            response.data.message,
            { root: true }
          );

          resolve(response);
        })
        .catch((error) => {
          commit("SET_SUCCESS", false);

          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );

          reject(error);
        });
    });
  },

  fetchDetail({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        // device_id: membuka halaman scan sekaligus mengklaim schedule ini untuk
        // perangkat ini. Backend balas 409 kalau HP lain sedang mengerjakannya.
        .get(`inv/stock-opname/stocker/detail/${payload}`, {
          params: { device_id: getDeviceId() },
        })
        .then((response) => {
          commit("SET_STOCKER_PAYLOAD", response.data.data);
          resolve();
        })
        .catch((error) => {
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },

  scanBarcode({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(`inv/stock-opname/stocker/scan-barcode/${payload.code}`, {
          params: {
            doc_num: payload?.doc_num,
            code_type: payload?.code_type || null,
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // silent: bulk scan melookup banyak SKU sekaligus; tanpa ini setiap SKU
          // tak dikenal memunculkan satu sweet alert sendiri.
          if (!payload?.silent) {
            dispatch(
              "Main/globalSweetAlert",
              error.response,
              { root: true }
            );
          }
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },

  submit({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .post("inv/stock-opname/stocker/submit/" + payload?.schedule_id, {
          ...payload?.payload,
          device_id: getDeviceId(),
          // Idempotency key per percobaan simpan: kalau request di-retry (jaringan
          // putus, tombol ke-tap dua kali), server mengabaikan save group kedua
          // sehingga qty tidak bertambah dua kali.
          client_save_id: newSaveId(),
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response?.data?.errors || "");
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },

  /**
   * Ambil 1 row schedule untuk manage/edit page. Pakai list endpoint dengan
   * view=100 lalu cari by ID — lebih ringan daripada view() yang juga balik
   * semua products + diff/details.
   */
  fetchScheduleForEdit({ dispatch }, scheduleId) {
    return $axios
      .get(`inv/stock-opname/list?view=100`)
      .then((res) => {
        const rows = res.data?.data?.data || [];
        const row = rows.find((r) => String(r.id) === String(scheduleId));
        return row || null;
      })
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      });
  },

  searchOitm({ dispatch }, query) {
    return $axios
      .get(`inv/stock-opname/search-oitm`, { params: { q: query } })
      .then((res) => res.data?.data || [])
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      });
  },

  updateSkuInSchedule({ commit }, payload) {
    return $axios
      .post(`inv/stock-opname/update-sku/${payload.schedule_id}`, {
        old_sku: payload.old_sku,
        new_sku: payload.new_sku,
      })
      .then((res) => res.data)
      .catch((error) => {
        commit("SET_ERRORS", error.response?.data?.errors || "");
        throw error;
      });
  },

  addProductToSchedule({ commit }, payload) {
    return $axios
      .post(`inv/stock-opname/add-product/${payload.schedule_id}`, {
        sku: payload.sku,
      })
      .then((res) => res.data)
      .catch((error) => {
        commit("SET_ERRORS", error.response?.data?.errors || "");
        throw error;
      });
  },

  removeProductFromSchedule({ commit }, payload) {
    return $axios
      .post(`inv/stock-opname/remove-product/${payload.schedule_id}`, {
        sku: payload.sku,
      })
      .then((res) => res.data)
      .catch((error) => {
        commit("SET_ERRORS", error.response?.data?.errors || "");
        throw error;
      });
  },

  syncProductFromUnion({ commit, dispatch }, sku) {
    commit("SET_SYNC_PRODUCT_LOADING", true);

    return $axios
      .post(`inv/stock-opname/sync-product/${sku}`)
      .then((res) => res.data)
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_SYNC_PRODUCT_LOADING", false);
      });
  },

  syncMissingProducts({ commit, dispatch }) {
    commit("SET_SYNC_MISSING_LOADING", true);

    return $axios
      .post(`inv/stock-opname/sync-missing-products`)
      .then((res) => res.data)
      .catch((error) => {
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_SYNC_MISSING_LOADING", false);
      });
  },

  uploadPicProof({ commit, dispatch }, payload) {
    commit("SET_UPLOAD_PIC_PROOF_LOADING", true);
    commit("SET_ERRORS", null);

    return $axios
      .post(`inv/stock-opname/upload-pic-proof/${payload.schedule_id}`, {
        pic_name: payload.pic_name,
        pic_photo: payload.pic_photo, // base64 data URL: "data:image/jpeg;base64,..."
      })
      .then((res) => {
        dispatch(
          "Main/globalSuccessSweetAlert",
          res.data?.message || "Bukti SO berhasil diunggah",
          { root: true }
        );
        return res.data?.data;
      })
      .catch((error) => {
        commit("SET_ERRORS", error.response?.data?.errors || "");
        dispatch("Main/globalSweetAlert", error.response, { root: true });
        throw error;
      })
      .finally(() => {
        commit("SET_UPLOAD_PIC_PROOF_LOADING", false);
      });
  },

  addMovementLine({ commit, dispatch }, payload) {
    commit("SET_MOVEMENT_LINE_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .post(`inv/stock-opname/stocker/movement-line/${payload.schedule_id}`, payload.payload)
        .then((res) => {
          // api.js MERESOLVE HTTP 404 sebagai sukses, jadi kegagalan "tidak
          // ditemukan" mendarat di sini, bukan di .catch(). Diperiksa lewat
          // data.status — jebakan yang sama sudah terdokumentasi di detail.vue.
          if (res?.data?.status === "error") {
            reject(res.data.message);
            return;
          }
          resolve(res?.data?.data ?? null);
        })
        .catch((error) => {
          reject(error.response?.data?.message || "Gagal menyimpan baris.");
        })
        .finally(() => {
          commit("SET_MOVEMENT_LINE_LOADING", false);
        });
    });
  },

  voidMovementLine({ commit }, payload) {
    commit("SET_MOVEMENT_LINE_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .post(`inv/stock-opname/stocker/movement-line/${payload.schedule_id}/${payload.line_id}/void`)
        .then((res) => {
          // 404 di sini artinya barisnya memang sudah tidak ada — orang lain
          // membatalkannya lebih dulu. Hasil akhirnya sama dengan yang diminta,
          // jadi diperlakukan sebagai SUKSES, bukan kegagalan yang membingungkan.
          if (res?.data?.status === "error" && res?.status !== 404) {
            reject(res.data.message);
            return;
          }
          resolve(res?.data?.data ?? null);
        })
        .catch((error) => {
          reject(error.response?.data?.message || "Gagal membatalkan baris.");
        })
        .finally(() => {
          commit("SET_MOVEMENT_LINE_LOADING", false);
        });
    });
  },

  importMacroRetur({ commit, dispatch }, payload) {
    return dispatch("importMovementFile", { ...payload, kind: "retur" });
  },

  importMacroSales({ commit, dispatch }, payload) {
    return dispatch("importMovementFile", { ...payload, kind: "sales" });
  },

  // Satu aksi untuk kedua unggahan: bentuk berkas dan bentuk ringkasannya sama
  // persis, yang membedakan hanya alamatnya (§5.G.1).
  importMovementFile({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    const path = payload.kind === "retur"
      ? `inv/stock-opname/stocker/import-macro-retur/${payload.schedule_id}`
      : `inv/stock-opname/stocker/import-macro-sales/${payload.schedule_id}`;

    return new Promise((resolve, reject) => {
      $axios
        .post(path, payload.body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          // Dulu `.then(() => resolve(true))` — response body dibuang, sehingga
          // ringkasan hasil unggahan (AC-04.5) mustahil ditampilkan.
          if (res?.data?.status === "error") {
            dispatch("Main/globalSweetAlert", { data: res.data }, { root: true });
            reject(res.data.message);
            return;
          }
          resolve(res?.data?.data ?? {});
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response?.data?.errors || "");
          dispatch(
            "Main/globalSweetAlert",
            error.response,
            { root: true }
          );
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
